import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Select } from "../../../../components/select";
import styles from "./styles";
import DropdownChevron from "../../../../assets/dropdown-chevron-closed.svg?inline";
import {
  useLocaleProvider,
  useTranslate,
} from "../../../../context/locale-provider";
import { useVerificationDetails } from "../../../../context/verification-details";
import { setCountryCode } from "../../../../state/verification-details/reducer";

export const CountrySelect = ({
  onItemClick,
  hasError,
  countriesData,
  availableCountries,
  assetsUrl,
}) => {
  const translate = useTranslate(useLocaleProvider());
  const [state, dispatch] = useVerificationDetails();
  const { countryCode } = state.verificationDetails;

  const [countryOptions, setCountryOptions] = useState();
  useEffect(() => {
    const getCountries = () => {
      const availablecountrieslist = availableCountries.map(
        (studentCountry) => {
          const country = countriesData.find(
            (country) => country.country === studentCountry
          );
          return {
            value: country.country,
            description: country.name,
            disabled: false,
          };
        }
      );
      setCountryOptions(availablecountrieslist);
    };

    getCountries();
  }, []);

  useEffect(() => {
    if (!countryCode && countryOptions) {
      const browseCountry = window.asos.webContext.getBrowseCountry();
      const countryInList = Boolean(
        countryOptions.find((option) => option.value === browseCountry)
      );
      dispatch(setCountryCode(countryInList ? browseCountry : "GB"));
    }
  }, [countryOptions, countryCode]);

  return (
    <div className={styles.container}>
      <label htmlFor="country" className="app_london3">
        {translate("sv_form_country_label")}:
      </label>
      <Select
        style={{
          backgroundImage: `url("${assetsUrl}/storesa/images/flags/${
            countryCode ? countryCode.toLowerCase() : ""
          }.png"), url("data:image/svg+xml,${encodeURIComponent(
            DropdownChevron
          )}")`,
        }}
        id="country"
        items={countryOptions?.length > 0 ? countryOptions : []}
        ariaLabel={translate("sv_form_country_aria")}
        errorMessage={hasError ? translate("sv_form_country_error") : ""}
        initialValue={countryCode}
        onItemClick={onItemClick}
      />
    </div>
  );
};

CountrySelect.propTypes = {
  onItemClick: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  countriesData: PropTypes.array.isRequired,
  availableCountries: PropTypes.array.isRequired,
  assetsUrl: PropTypes.string.isRequired,
};
